export default "__VITE_ASSET__d711776e__"